import { assign, fromPromise, setup } from 'xstate';
import { EMPTY_ADDRESS_FORM } from '~/constants';
import { showAxiosErrorAction } from '~/features/actions';
import {
  loadingFalse,
  loadingTrue,
  loadPdf,
  saveWizardDraft,
  setMagicLink,
  setNextStep,
  setNotFound,
  setPeerReference,
  setPrevStep,
  updatePeerRef,
} from './actions';
import { PEER_REFERENCE_API_CALLS } from './api';
import { defaultPeerReference } from './constants';
import { Events } from './events';
import { Context, Scope } from './types';
export const peerRefMachine = setup({
  actors: {
    getRef: fromPromise(PEER_REFERENCE_API_CALLS.get),
    patchRef: fromPromise(PEER_REFERENCE_API_CALLS.patch),
    submitRef: fromPromise(PEER_REFERENCE_API_CALLS.create),
  },
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
  actions: {
    sendError: showAxiosErrorAction,
    loadingTrue: assign(loadingTrue),
    loadingFalse: assign(loadingFalse),
    setMagicLink: assign(setMagicLink),
    setPeerReference: assign(setPeerReference),
    setNextStep: assign(setNextStep),
    setPrevStep: assign(setPrevStep),
    saveWizardDraft: assign(saveWizardDraft),
    setNotFound: assign(setNotFound),
    updatePeerReference: assign(updatePeerRef),
    loadPDF: loadPdf,
  },
}).createMachine({
  context: ({ input }) => ({
    loading: false,
    address: EMPTY_ADDRESS_FORM,
    peerReference: defaultPeerReference,
    magicLink: input.magicLink || undefined,
    formUi: {},
    form: {},
    defaultJSONFormData: {},
    personalInfo: undefined,
    step: 0,
    notFound: false,
  }),
  initial: '$_IDLE',
  on: {
    ON_GET: {
      target: '.$_GET',
    },
    ON_WIZ_NEXT_PAGE: {
      actions: ['setNextStep'],
    },
    ON_WIZ_PREV_PAGE: {
      actions: ['saveWizardDraft', 'setPrevStep'],
    },
    ON_WIZ_UPDATE: {
      actions: ['setNextStep', 'updatePeerReference'],
      target: '.$_PATCH',
    },
    ON_WIZ_SUBMIT: {
      actions: ['setNextStep', 'updatePeerReference'],
      target: '.$_SUBMIT',
    },
  },
  states: {
    $_IDLE: {},
    $_VIEW: {},
    $_PATCH: {
      invoke: {
        id: 'patchRef',
        src: 'patchRef',
        input: ({ context, event }) => ({ context, event }) as { context: Context; event: Events },
        onDone: {
          target: '$_GET',
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError'],
        },
      },
    },
    $_GET: {
      invoke: {
        id: 'getRef',
        src: 'getRef',
        input: ({ context, event }) => ({ context, event }) as Scope,
        onDone: {
          target: '$_VIEW',
          actions: ['setPeerReference', 'loadingFalse'],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError', 'loadingFalse', 'setNotFound'],
        },
      },
    },
    $_SUBMIT: {
      invoke: {
        id: 'submitRef',
        src: 'submitRef',
        input: ({ context, event }) => ({ context, event }) as { context: Context; event: Events },
        onDone: {
          target: '$_VIEW',
          actions: ['loadPDF'],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError'],
        },
      },
    },
  },
});
